home_handler = {

    properties: {
      title: ''

    },

    onLoad: function(){
        var self = this;
        self.updateLS();
        view_handler.resetSelection();
        view_handler.properties.featureID = '';

    },

    getRequest: function(){
        var self = this;
        var id = properties.loadHashID;

        if (feedbackData.data[id]){
            window.location.href = "#/view/" + id;
        }
    },

    //Update Local Storage
    updateLS: function(){
        try {
          properties.pvlk =  JSON.parse( localStorage.getItem( 'pvlk-pdf-beta' ) ) || {};
        }
        catch(e) {
          console.log(e);
        }
    },

    //Add to Local Storage
    addLS: function(id){
        var self = this;
        var pg = {};

        pg.ID = id || null;
        
        if (!properties.pvlk){
          properties.pvlk = {}
        }

        if (pg.ID){
          properties.pvlk[pg.ID] = pg;
        }

        try {
          localStorage.setItem( 'pvlk-pdf-beta', JSON.stringify(properties.pvlk) );
        }
        catch(e) {
          return false;
        }
        self.updateLS();
        return true;
    },


    scrollTop: function(){
        $('html, body').animate({ 
           scrollTop: 0}, 
           800, 
           "swing"
        );
    },

    scrollContent: function(){
        $('html, body').animate({ 
           scrollTop: $('.content-root').offset().top}, 
           800, 
           "swing"
        );
    },

    tempSidebar: function(){

      $('#content-root').addClass('noswipe');
      $('#outerContainer').addClass('sidebarOpen');

    },

    showSidebar: function(){
      var self = this;
      $('#content-root').removeClass('swipe');
      $('#outerContainer').addClass('sidebarOpen');
    },

    hideSidebar: function(){
      var self = this;
      $('#outerContainer').removeClass('sidebarOpen');
      $('#content-root').addClass('swipe');
      if ($('#outerContainer').hasClass('sidebarOpen') == true){
          self.scrollContent();
      }
      else {
          self.scrollTop();
      }
    },

    getUrlParameter: function(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1].replace('/', '');
            }
        }
    },

    wordCount: function( val ){
        var wom = val.match(/\S+/g);
        return val.length || 0;
        // return wom ? wom.length : 0;
    },

    formatText: function(comment) {
        comment = comment.replace(/(<([^>]+)>)/gi, "");
        if ($.trim(comment).length > 0) {
            return comment;
        }
        return "";
    },


    events: function() {
        var self = this;
        self.onLoad();

        $('.edit-cancel').click(function(event) {
            feedback_handler.turnOff();
        });

        $('.add-feedback').click(function(event) {

          if (!properties.tutorial){
              properties.tutorial = true;
              $("#ex1").modal({
                  clickClose: false
              });
          }

          feedback_handler.turnOn();
          return false;
        });

        document.addEventListener('pagechange', function (e) {
          if (e.pageNumber !== e.previousPageNumber) {
            $section = $('.jump-nav a[data-page="' + e.pageNumber + '"]');

            if ($section.length) {
              $('.jump-nav a').removeClass('active');
              $section.addClass('active');
            }
            if (window.outerWidth < 768) {
              home_handler.hideSidebar();
            }
          }
        });

        $('.jump-nav a').on('click', function(){
          var page = $(this).data('page');
          PDFViewerApplication.page = page;
        });

        $('select[name=chapter]').on('change', function() {
          var url = this.value;
          window.location.href = "?file=" + url + "#/";
        })

    }
}
